import { render, staticRenderFns } from "./DifferentBankModal.vue?vue&type=template&id=585373de"
import script from "./DifferentBankModal.vue?vue&type=script&lang=ts"
export * from "./DifferentBankModal.vue?vue&type=script&lang=ts"
import style0 from "./DifferentBankModal.vue?vue&type=style&index=0&id=585373de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports